import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCloud, FiSun, FiCloudRain, FiThermometer, FiWind } = FiIcons;

const WeatherWidget = ({ lat, lon }) => {
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const response = await fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m,relative_humidity_2m,weather_code,wind_speed_10m`
        );
        const data = await response.json();
        setWeather(data.current);
      } catch (error) {
        console.error("Weather fetch failed", error);
      } finally {
        setLoading(false);
      }
    };

    if (lat && lon) fetchWeather();
  }, [lat, lon]);

  const getWeatherIcon = (code) => {
    if (code === 0) return FiSun;
    if (code > 0 && code < 45) return FiCloud;
    return FiCloudRain;
  };

  if (loading) return <div className="animate-pulse h-10 w-32 bg-slate-200 rounded-full"></div>;
  if (!weather) return null;

  return (
    <div className="flex items-center space-x-4 bg-indigo-900 text-white px-5 py-2.5 rounded-full shadow-lg border border-indigo-800">
      <div className="flex items-center space-x-2">
        <SafeIcon icon={getWeatherIcon(weather.weather_code)} className="text-xl text-yellow-400" />
        <span className="font-bold text-lg">{Math.round(weather.temperature_2m)}°C</span>
      </div>
      <div className="hidden sm:flex items-center space-x-3 border-l border-indigo-700 pl-3">
        <div className="flex items-center space-x-1">
          <SafeIcon icon={FiWind} className="text-indigo-300 text-xs" />
          <span className="text-xs font-medium">{weather.wind_speed_10m} km/h</span>
        </div>
      </div>
    </div>
  );
};

export default WeatherWidget;